import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { HEADER_HEIGHT } from '../../constants';
import type { ReaderViewState } from '../../types';
import { shouldShowAds } from '../../util/ads-utils';
import { AdsLeaderBoard } from '../Ads';
import { AdsBeforeReader } from '../Ads/AdsBeforeReader';
import { DocumentActions } from '../DocumentActions';
import DocumentContext from '../DocumentPage/DocumentContext';
import type { GridLayout } from '../DocumentPage/useGridLayout';
import { EmbedReader } from '../EmbedReader';
import { TextVersion } from '../TextVersion';

const getReaderHeight = (layout: GridLayout, view: ReaderViewState) => {
    switch (layout) {
        case 'tiny':
            return css`
                height: 100vh;
            `;
        case 'twoColumn':
        case 'wideScreen':
            if (view === 'large') {
                return css`
                    height: calc(98vh - ${HEADER_HEIGHT});
                    min-height: 300px;
                    max-height: 900px;
                `;
            }
        default:
            return css`
                height: calc(72vh - ${HEADER_HEIGHT});
                min-height: 300px;
                max-height: 700px;
            `;
    }
};

const Root = styled.main<{ layout: GridLayout; view: ReaderViewState }>`
    position: relative;
    grid-area: reader;
    display: flex;
    flex-direction: column;
    ${({ layout, view }) => getReaderHeight(layout, view)}
`;

export const ReaderWrapper: React.FC = () => {
    const context = useContext(DocumentContext);
    const {
        crawler,
        appState: {
            currentLayout: { name: layout },
            readerViewState: [readerViewState],
        },
    } = context;
    if (crawler) {
        return <TextVersion />;
    }

    return (
        <Root aria-label="Document reader" layout={layout} view={readerViewState}>
            {shouldShowAds({ context }) ? (
                layout === 'tiny' ? (
                    <AdsBeforeReader />
                ) : layout !== 'wideScreen' ? (
                    <AdsLeaderBoard />
                ) : null
            ) : null}
            <EmbedReader />
            <DocumentActions />
        </Root>
    );
};
